import { render } from "./EmptyStateDashboard.vue?vue&type=template&id=6ba09997"
import script from "./EmptyStateDashboard.vue?vue&type=script&lang=js"
export * from "./EmptyStateDashboard.vue?vue&type=script&lang=js"

import "./EmptyStateDashboard.vue?vue&type=style&index=0&id=6ba09997&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__